<template>

	<a class="button-primary" :href="linkURL">{{ linkText }}</a>
	
</template>

<script>
	
	export default {
		name: 'PrimaryButton',
		
		props: ['linkURL', 'linkText']
	}
	
</script>